import React from 'react';

/**
 * Pill with leading dot + label. Used to surface ComputerEase
 * Integration status (Enabled / Disabled).
 *
 *   kind: 'enabled' → success-soft bg, success fg
 *   kind: 'disabled' → warning-soft bg, warning fg
 *
 * Borders use a 22%-mix of the foreground color over transparent for a
 * subtle ring consistent with our other status surfaces.
 */
const MAP = {
  enabled: { bg: 'var(--success-soft)', fg: 'var(--success)' },
  disabled: { bg: 'var(--warning-soft)', fg: 'var(--warning)' },
};

export default function StatusBadge({ kind = 'enabled', label }) {
  const c = MAP[kind] || MAP.enabled;
  return (
    <span
      style={{
        display: 'inline-flex',
        alignItems: 'center',
        gap: 5,
        padding: '2px 9px',
        borderRadius: 999,
        background: c.bg,
        color: c.fg,
        border: `1px solid color-mix(in oklch, ${c.fg} 22%, transparent)`,
        fontSize: 12.5,
        fontWeight: 500,
        whiteSpace: 'nowrap',
      }}
    >
      <span style={{ width: 5, height: 5, borderRadius: 99, background: c.fg, flexShrink: 0 }} />
      {label}
    </span>
  );
}
